import { render, staticRenderFns } from "./dsar-monitoring-modal.vue?vue&type=template&id=7b123ac4&"
import script from "./dsar-monitoring-modal.vue?vue&type=script&lang=js&"
export * from "./dsar-monitoring-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports